import Vue from "vue";
class ReteComponentStore {
  constructor() {
    if (!ReteComponentStore.instance) {
      this._data = [];
      this._nodeCat = {};
      ReteComponentStore.instance = this;
    }

    return ReteComponentStore.instance;
  }

  add(item) {
    let exist = this._data.find(d => d.name === item.name) !== undefined;
    if (exist === false) {
      this._data.push(item);
      this.addNodeCategory(item);
    }
  }

  get() {
    return this._data.slice(0);
  }
  getNodeCategory() {
    return this._nodeCat;
  }

  addNodeCategory(item){
    if(item._categories != [] && item._categories !== undefined){
      var tempstring = "";
      var exist = false;
      for (var i = 0; i < item._categories.length; i++) {
        tempstring = item._categories[i];
        if(tempstring == "tryMe") continue;
        exist = tempstring in this._nodeCat;
        console.log("exist:" + exist);
        if (exist === false) {
          this._nodeCat[item._categories[i]] = [{category:tempstring,nodename:item.name}];
        }
        else{
          this._nodeCat[item._categories[i]].push({category:tempstring,nodename:item.name});
        }
      }
    }
    for(var key in this._nodeCat) {
      console.log(JSON.stringify(key));
      console.log(JSON.stringify(this._nodeCat[key]));
    }

  }

  reset(){
    this._data.length = 0;
    for (var member in this._nodeCat) delete this._nodeCat[member];

  }

  loadComponents(loadAll) {
    //Search for js file in rete-components and force them all to be imported
  
    const requireComponent = require.context(
      // The relative path of the components folder
      "./rete-components",
      // Whether or not to look in subfolders
      true,
      // The regular expression used to match base component filenames
      /\w+\.(js)$/
    );
    requireComponent.keys().forEach(fileName => {
      // Get component config
      const componentConfig = requireComponent(fileName);
  
      //Get PascalCase name of component
      const componentName =
        // Gets the file name regardless of folder depth
        fileName
          .split("/")
          .pop()
          .replace(/\.\w+$/, "");
  
   
  
      // Register component globally
      Vue.component(
        componentName,
        // Look for the component options on `.default`, which will
        // exist if the component was exported with `export default`,
        // otherwise fall back to module's root.
        componentConfig.default || componentConfig
      );

      var cc = new componentConfig.default();

      if(!loadAll && cc._categories != [] && cc._categories !== undefined &&  cc._categories.filter(x => x == "tryMe").length != 0 ){
        console.log("loading rete-components " + componentName);
        this.add(cc);
      }
      else if(loadAll){
        console.log("loading rete-components " + componentName);
        this.add(cc);
      }
    });
  }
}

const instance = new ReteComponentStore();
Object.freeze(instance);
export default instance;


